import React, { useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/navigation";
// @ts-ignore
import "swiper/css/pagination";
import { getRequest } from "../../helpers/api.helper";
import {
  FaChevronLeft,
  FaChevronRight,
  FaExternalLinkAlt,
  FaFacebook,
  FaInstagram,
  FaLink,
  FaLinkedin,
  FaPlay,
  FaQuoteLeft,
  FaSearch,
  FaStar,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { UPLOAD_URL } from "../../utils/constants";
import { hasActiveMembership, isAccountSuspended } from "../../utils/bureau";
import { bureauInfo, ProfileType } from "../../types";
import { ChevronRight, Download, PhoneCall } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import {
  getPrivacyOverlayLabel,
  shouldBlurProfileImage,
} from "../../utils/imagePrivacy";
import { calculateAge } from "../../helpers/function.helper";
import Step1 from "../UserCreation/Step1";
import type { UserProfileId } from "../../types/user.creation";

type LocationType = {
  id: string;
  branch_manager_name: string;
  contact_details: string;
  house_no: string;
  street: string;
  city: string;
  district: string;
  state: string;
  country: string;
  google_map_link: string;
};

const MyWebSite = () => {
  const { id, name } = useParams(); // Get 'id' and 'pageName' from URL
  const navigate = useNavigate();
  const location = useLocation();
  const [bureauInfo, setBureauInfo] = useState<bureauInfo>();
  const [welcomeImageBanner, setWelcomeImageBanner] = useState("");
  const [bannerImages, setBannerImages] = useState([]);
  const [email, setEmail] = useState(""); // New state variable for email
  const [mobile, setMobile] = useState("");
  const [about, setAbout] = useState("");

  const [navbarLogo, setNavbarLogo] = useState("");

  // New state for testimonials and customized links
  const [testimonials, setTestimonials] = useState<any>([]);
  const [customizedLinks, setCustomizedLinks] = useState([]);
  const [packages, setPackages] = useState([]);
  const [terms, setTerms] = useState([]);
  // New state for testimonials modal
  const [showTestimonialsModal, setShowTestimonialsModal] = useState(false);
  const [showMoreInfoModal, setShowMoreInfoModal] = useState(false);

  // Add social media state variables
  const [facebookUrl, setFacebookUrl] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [linkedinUrl, setLinkedinUrl] = useState("");
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [profile, setProfile] = useState<any>(null);

  // Add state for services
  const [services, setServices] = useState([]);

  // Add state for locations
  const [locations, setLocations] = useState<LocationType[]>([]);

  const [successStories, setSuccessStories] = useState([]);
  // Add state for locations modal
  const [showLocationsModal, setShowLocationsModal] = useState(false);
  const [step1Current, setStep1Current] = useState(1);
  const [step1CompletedSteps, setStep1CompletedSteps] = useState<number[]>([]);
  const [step1ProfileId, setStep1ProfileId] = useState<UserProfileId>();
  const step1Steps = [
    {
      id: 1,
      title: "Profile",
      completed: step1CompletedSteps.includes(1),
    },
  ];

  const [maleProfiles, setMaleProfiles] = useState<{
    profiles: ProfileType[];
    count: number;
  }>({ profiles: [], count: 0 });
  const [femaleProfiles, setFemaleProfiles] = useState<{
    profiles: ProfileType[];
    count: number;
  }>({ profiles: [], count: 0 });
  const { t } = useLanguage();
  const isPaidAccount = hasActiveMembership(bureauInfo?.paymentStatus);
  const isSiteSuspended = isAccountSuspended(bureauInfo?.suspend);
  const bureauTitle = bureauInfo?.bureauName || name || "";
  const fetchGenderProfiles = async (gender: "male" | "female") => {
    if (!id) return;
    try {
      const response = await getRequest(
        `/bureau/website/${id}/profiles/${gender}?page=1&limit=12`,
      );
      if (response.success) {
        const payload = response.data?.profiles || response.data?.data || [];
        const total =
          response.data?.count ?? response.data?.total ?? payload.length ?? 0;
        if (gender === "male") {
          setMaleProfiles({
            profiles: payload,
            count: total,
          });
        } else {
          setFemaleProfiles({
            profiles: payload,
            count: total,
          });
        }
      }
    } catch (error) {
      console.error(`Error fetching ${gender} profiles:`, error);
    }
  };

  useEffect(() => {
    const fetchBureauDetails = async () => {
      try {
        const response = await getRequest(`/bureau/website/${id}`);
        if (response.success) {
          const {
            profile,
            sliderImages,
            testimonials,
            customizedLinks,
            packages,
            services,
            locations,
            successStories,
            terms,
            maleProfiles,
            femaleProfiles,
            totalMaleProfiles,
            totalFemaleProfiles,
          } = response.data;

          setWelcomeImageBanner(profile.welcomeImageBanner);
          setEmail(profile.email);
          setMobile(profile.mobileNumber);
          setAbout(profile.about);
          setNavbarLogo(profile.navbarLogo);
          setFacebookUrl(profile.facebook || "");
          setTwitterUrl(profile.twitter || "");
          setInstagramUrl(profile.instagram || "");
          setLinkedinUrl(profile.linkedin || "");
          setYoutubeUrl(profile.youtube || "");
          setLocations(locations);
          setBannerImages(sliderImages);
          setBureauInfo({ ...profile });
          setCustomizedLinks(customizedLinks);
          setSuccessStories(successStories);
          setTestimonials(testimonials);
          setPackages(packages);
          setServices(services);
          setTerms(terms);
          setProfile(profile);
          // setMaleProfiles({
          //   profiles: maleProfiles,
          //   count: totalMaleProfiles,
          // });
          // setFemaleProfiles({
          //   profiles: femaleProfiles,
          //   count: totalFemaleProfiles,
          // });
        }
      } catch (error) {
        console.error("Error fetching bureau details:", error);
      }
    };

    fetchBureauDetails();
  }, [id]);

  useEffect(() => {
    if (!id) return;
    fetchGenderProfiles("male");
    fetchGenderProfiles("female");
  }, [id]);

  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const interval = setInterval(() => {
      const el = document.getElementById(location.state.scrollTo);

      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        clearInterval(interval);
        navigate(location.pathname, {
          replace: true,
          state: {},
        });
      }
    }, 200);

    return () => clearInterval(interval);
  }, [location]);

  useEffect(() => {
    if (!customizedLinks.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target as HTMLVideoElement;
          if (!target) return;
          if (entry.isIntersecting) {
            const playPromise = target.play();
            if (playPromise && typeof playPromise.then === "function") {
              playPromise.catch(() => {});
            }
          } else {
            target.pause();
          }
        });
      },
      { threshold: 0.6 },
    );

    Object.values(videoRefs.current).forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => observer.disconnect();
  }, [customizedLinks]);

  const openLink = (url: string) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const getTestimonialImageUrl = (testimonial: any) => {
    if (!testimonial?.image) {
      return "";
    }

    if (testimonial.image.startsWith("http")) {
      return testimonial.image;
    }

    return `${UPLOAD_URL}/bureaus/testimonials/${testimonial.image}`;
  };

  const isVideoUrl = (url: string) =>
    /\.(mp4|webm|ogg)(\?.*)?$/.test(url.toLowerCase());

  // Touch references
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const videoRefs = useRef<Record<string, HTMLVideoElement | null>>({});
  const [currentSlide, setCurrentSlide] = useState(0);
  // Separate intervals for each slider
  const slideInterval = useRef<any>(null);

  // Auto-slide effect for main slider
  useEffect(() => {
    if (bannerImages && bannerImages.length > 1) {
      startSlideTimer();
    }

    return () => {
      if (slideInterval.current) {
        clearInterval(slideInterval.current);
      }
    };
  }, [bannerImages]);

  // Timer functions for main slider
  const startSlideTimer = () => {
    if (!bannerImages || bannerImages.length <= 1) return;

    if (slideInterval.current) {
      clearInterval(slideInterval.current);
    }

    slideInterval.current = setInterval(() => {
      setCurrentSlide((prev) =>
        prev === bannerImages.length - 1 ? 0 : prev + 1,
      );
    }, 2000);
  };

  const restartTimer = () => {
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
      startSlideTimer();
    }
  };

  const goToPrevSlide = () => {
    if (!bannerImages?.length) return;

    setCurrentSlide((prev) =>
      prev === 0 ? bannerImages.length - 1 : prev - 1,
    );
    restartTimer();
  };

  const goToNextSlide = () => {
    if (!bannerImages?.length) return;

    setCurrentSlide((prev) =>
      prev === bannerImages.length - 1 ? 0 : prev + 1,
    );
    restartTimer();
  };

  const socials = [
    {
      key: "facebook",
      url: facebookUrl,
      label: "Facebook",
      Icon: FaFacebook,
      bg: "bg-blue-600",
    },
    {
      key: "twitter",
      url: twitterUrl,
      label: "Twitter",
      Icon: FaTwitter,
      bg: "bg-sky-500",
    },
    {
      key: "instagram",
      url: instagramUrl,
      label: "Instagram",
      Icon: FaInstagram,
      bg: "bg-pink-500",
    },
    {
      key: "linkedin",
      url: linkedinUrl,
      label: "LinkedIn",
      Icon: FaLinkedin,
      bg: "bg-blue-700",
    },
    {
      key: "youtube",
      url: youtubeUrl,
      label: "YouTube",
      Icon: FaYoutube,
      bg: "bg-red-600",
    },
  ].filter((s) => !!s.url);

  const useStackReveal = () => {
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      const el = ref.current;
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("visible");
          }
        },
        { threshold: 0.2 },
      );

      observer.observe(el);

      return () => observer.disconnect();
    }, []);

    return ref;
  };

  useEffect(() => {
    const cards = document.querySelectorAll<HTMLElement>(".stack-card");
    if (!cards.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            el.classList.add("visible");
            io.unobserve(el); // reveal once (premium)
          }
        });
      },
      { threshold: 0.2 },
    );

    cards.forEach((c) => io.observe(c));
    return () => io.disconnect();
  }, [maleProfiles.profiles, femaleProfiles.profiles]);

  useEffect(() => {
    const elements = document.querySelectorAll<HTMLElement>(
      ".reveal-left, .reveal-right, .reveal-up",
    );

    if (!elements.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            el.classList.add("visible");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.25 },
    );

    elements.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, [packages, successStories, services, locations]);

  const formattedMobile = mobile.replace(/\D/g, "");

  let whatsappNumber = formattedMobile;

  if (formattedMobile.length === 10) {
    whatsappNumber = `91${formattedMobile}`;
  } else if (
    formattedMobile.length === 12 &&
    formattedMobile.startsWith("91")
  ) {
    whatsappNumber = formattedMobile;
  }
  return (
    <div className="overflow-x-hidden">
      <Navbar navbarLogo={navbarLogo} bureauName={name} />

      <main className="safe-area-bottom overflow-x-hidden pt-40 sm:pt-32 sm:pb-12 bg-gradient-to-b from-[#f6f4ef] via-white to-[#eff6f3]">
        {isSiteSuspended && (
          <div className="bg-red-700 text-white text-center px-4 py-3">
            <p className="font-semibold text-sm sm:text-base">
              {t("alerts.suspended.websiteTitle")}
            </p>
          </div>
        )}
        <div className="block sm:hidden pt-5 flex flex-wrap gap-3 bg-white justify-center pb-6">
          <button
            type="button"
            onClick={() =>
              window.open(
                `https://meemarriage.com/login`,
                "_blank",
              )
            }
            className="px-4 py-1 rounded-full font-semibold bg-rose-600 text-white shadow-md shadow-rose-200/60 hover:bg-rose-700 transition"
          >
            Login
          </button>
          <a
            href={`/profile/${id}`}
            className="px-4 py-1 rounded-full font-semibold border border-rose-300 text-rose-700 hover:bg-rose-50 transition"
          >
            Free Register
          </a>
        </div>
        <section className="sm:hidden sm:py-12 bg-gradient-to-b from-white via-rose-50 to-pink-50">
          <div className="container mx-auto sm:px-4 md:px-8">
            {bannerImages && bannerImages.length > 0 && (
              <div className="relative overflow-hidden shadow-2xl">
                <div className="relative w-full h-52">
                  {bannerImages.map((image: any, index) => (
                    <div
                      key={image.id || index}
                      className={`absolute inset-0 transition-opacity duration-700 ${
                        currentSlide === index ? "opacity-100" : "opacity-0"
                      }`}
                    >
                      <img
                        src={`${UPLOAD_URL}/bureaus/banners/${image.imageUrl}`}
                        className="w-full h-full object-full object-center"
                      />

                      {/* overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-rose-900/40 to-transparent" />
                    </div>
                  ))}
                </div>

                {/* arrows */}
                <button
                  onClick={goToPrevSlide}
                  className="absolute left-4 top-1/2 -translate-y-1/2
          bg-white/80 backdrop-blur p-2 rounded-full shadow"
                >
                  <FaChevronLeft size={20} />
                </button>

                <button
                  onClick={goToNextSlide}
                  className="absolute right-4 top-1/2 -translate-y-1/2
          bg-white/80 backdrop-blur p-2 rounded-full shadow"
                >
                  <FaChevronRight size={20} />
                </button>
              </div>
            )}
          </div>
        </section>

        <section className="hidden sm:block sm:py-12 bg-gradient-to-b from-white via-rose-50 to-pink-50">
          <div className="container mx-auto sm:px-4 md:px-8">
            {bannerImages && bannerImages.length > 0 && (
              <div className="relative rounded-lg sm:rounded-3xl overflow-hidden shadow-2xl border border-rose-100">
                <div className="relative w-full h-64 md:h-96">
                  {bannerImages.map((image: any, index) => (
                    <div
                      key={image.id || index}
                      className={`absolute inset-0 transition-opacity duration-700 ${
                        currentSlide === index ? "opacity-100" : "opacity-0"
                      }`}
                    >
                      <img
                        src={`${UPLOAD_URL}/bureaus/banners/${image.imageUrl}`}
                        className="w-full h-full object-full object-center"
                      />

                      {/* overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-rose-900/40 to-transparent" />
                    </div>
                  ))}
                </div>

                {/* arrows */}
                <button
                  onClick={goToPrevSlide}
                  className="absolute left-4 top-1/2 -translate-y-1/2
          bg-white/80 backdrop-blur p-2 rounded-full shadow"
                >
                  <FaChevronLeft size={20} />
                </button>

                <button
                  onClick={goToNextSlide}
                  className="absolute right-4 top-1/2 -translate-y-1/2
          bg-white/80 backdrop-blur p-2 rounded-full shadow"
                >
                  <FaChevronRight size={20} />
                </button>
              </div>
            )}
          </div>
        </section>

        <section className="reveal-up py-8 sm:py-16 bg-gradient-to-b from-rose-50 via-white to-pink-50">
          <div className="max-w-7xl sm:max-w-5xl mx-auto px-4">
            <div
              className="text-center mb-8 reveal-up"
              style={{ animationDelay: "0.2s" }}
            >
              <h2 className="text-xl sm:text-3xl font-semibold text-black-900 font-serif">
                Create Profile
              </h2>
              <p className="text-rose-500 mt-2">
                Start by creating your profile in a few simple steps
              </p>
            </div>

            <div
              className="bg-white rounded-3xl shadow-3xl shadow-rose-200/60 border border-rose-100 p-4 sm:p-6 reveal-up"
              style={{ animationDelay: "0.4s" }}
            >
              <Step1
                bureauId={id}
                otherBureauId={id}
                whose="own"
                steps={step1Steps}
                currentStep={step1Current}
                setCurrentStep={setStep1Current}
                setCompletedSteps={setStep1CompletedSteps}
                setProfileId={setStep1ProfileId}
              />
            </div>
          </div>
        </section>

        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(244,63,94,0.22),_transparent_55%)]" />
          {/* {welcomeImageBanner && (
            <img
              src={`${UPLOAD_URL}/bureaus${welcomeImageBanner}`}
              alt="Welcome banner"
              className="absolute inset-0 h-full w-full object-cover opacity-20"
            />
          )} */}
          <div className="container mx-auto px-4 md:px-8 relative z-10">
            <div className="grid gap-8 lg:grid-cols-[1.2fr,0.8fr] items-center py-8 sm:py-10 md:py-16">
              <div className="reveal-up">
                <div className="inline-flex items-center gap-2 rounded-full border border-rose-200 bg-white/70 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-rose-700">
                  Trusted Matchmaking Platform
                </div>

                <h1
                  className="bureau-display mt-4 text-lg sm:text-4xl md:text-5xl font-bold text-slate-900 reveal-up"
                  style={{ transitionDelay: "0.1s" }}
                >
                  {bureauTitle}
                </h1>

                <p
                  className="mt-3 text-base sm:text-lg bureau-muted max-w-xl reveal-up"
                  style={{ transitionDelay: "0.2s" }}
                >
                  Curated profiles, verified details, and a dedicated team to
                  help you find the right match with confidence.
                </p>

                <div
                  className="hidden sm:flex mt-6 flex flex-wrap gap-3 reveal-up"
                  style={{ transitionDelay: "0.3s" }}
                >
                  <button
                    type="button"
                    onClick={() =>
                      window.open(
                        `https://meemarriage.com/${id}/${name}/search`,
                        "_blank",
                      )
                    }
                    className="px-6 py-3 rounded-full font-semibold bg-rose-600 text-white shadow-md shadow-rose-200/60 hover:bg-rose-700 transition"
                  >
                    Search Profiles
                  </button>
                  <a
                    href={`/profile/${id}`}
                    className="px-6 py-3 rounded-full font-semibold border border-rose-300 text-rose-700 hover:bg-rose-50 transition"
                  >
                    Free Register
                  </a>
                </div>
              </div>
              <div
                className="bg-white/85 backdrop-blur rounded-3xl border border-white shadow-xl p-2 sm:p-6 reveal-up"
                style={{ transitionDelay: "0.4s" }}
              >
                <div className="grid grid-cols-3 gap-4">
                  <div
                    className="rounded-2xl bg-rose-50 px-4 py-5 reveal-up"
                    style={{ transitionDelay: "0.5s" }}
                  >
                    <div className="text-xs uppercase tracking-[0.2em] text-rose-700">
                      Male Profiles
                    </div>
                    <div className="text-2xl font-bold text-slate-900 mt-2">
                      {maleProfiles.count}
                    </div>
                  </div>
                  <div
                    className="rounded-2xl bg-pink-50 px-4 py-5 reveal-up"
                    style={{ transitionDelay: "0.6s" }}
                  >
                    <div className="text-xs uppercase tracking-[0.2em] text-pink-700">
                      Female Profiles
                    </div>
                    <div className="text-2xl font-bold text-slate-900 mt-2">
                      {femaleProfiles.count}
                    </div>
                  </div>
                  <div
                    className="rounded-2xl bg-slate-50 px-4 py-5 reveal-up"
                    style={{ transitionDelay: "0.7s" }}
                  >
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-600">
                      Success Stories
                    </div>
                    <div className="text-2xl font-bold text-slate-900 mt-2">
                      {successStories.length}
                      <small className="text-sm align-top">+</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 sm:py-16 bg-gradient-to-b from-rose-50 via-white to-pink-50">
          <div id="male-profiles" className="max-w-7xl mx-auto px-4">
            <div className="flex justify-between mb-8">
              <h2 className="text-xl sm:text-3xl font-serif text-rose-900">
                Male Profiles
              </h2>

              <button
                onClick={() => navigate(`/${id}/${name}/profiles/male`)}
                className="text-rose-700 font-semibold"
              >
                {maleProfiles.count} Profiles →
              </button>
            </div>

            {/* Swiper Section */}
            {maleProfiles.profiles.length === 0 ? (
              <div className="flex items-center justify-center py-10 text-sm sm:text-base text-gray-500 border border-dashed border-gray-300 rounded-xl bg-white/60 text-center">
                {t("dashboard.noProfiles")}
              </div>
            ) : (
              <>
                {/* ✅ Mobile Grid (shows 8 profiles) */}
                <div className="grid grid-cols-2 gap-3 sm:hidden ">
                  {maleProfiles.profiles.slice(0, 8).map((profile, index) => {
                    const blurPhoto = shouldBlurProfileImage(
                      profile.imagePrivacy,
                    );
                    return (
                      <div
                        key={profile.id ?? `male-grid-${index}`}
                        className="stack-card"
                        style={{ animationDelay: `${index * 120}ms` }}
                      >
                        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition cursor-pointer">
                          <div className="relative h-36 overflow-hidden bg-gray-100">
                            <img
                              src={`${UPLOAD_URL}/users/profile_pic/${profile.image}`}
                              alt={profile.fullName}
                              className={`w-full h-full object-cover ${
                                blurPhoto
                                  ? "blur-sm scale-110 brightness-90"
                                  : ""
                              }`}
                            />
                            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                          </div>
                        </div>
                        <div className="p-2 text-gray">
                          <h3 className="font-semibold text-xs truncate">
                            {profile.fullName}
                          </h3>
                          <p className="text-[11px] opacity-90">
                            {calculateAge(profile.dateOfBirth)} yrs •{" "}
                            {profile.height}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="hidden sm:block">
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={16}
                    slidesPerView={1.2}
                    freeMode={true}
                    grabCursor={true}
                    breakpoints={{
                      640: { slidesPerView: 2.2 },
                      1024: { slidesPerView: 3.2 },
                      1280: { slidesPerView: 4.2 },
                    }}
                    className="!pb-2"
                  >
                    {maleProfiles.profiles.map((profile, index) => {
                      const blurPhoto = shouldBlurProfileImage(
                        profile.imagePrivacy,
                      );

                      return (
                        <SwiperSlide key={profile.id ?? `male-${index}`}>
                          <div
                            className="stack-card"
                            style={{ animationDelay: `${index * 120}ms` }}
                          >
                            {/* Image Card */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition cursor-pointer mx-1">
                              <div className="relative h-52 sm:h-56 overflow-hidden bg-gray-100">
                                <img
                                  src={`${UPLOAD_URL}/users/profile_pic/${profile.image}`}
                                  alt={profile.fullName}
                                  className={`w-full h-full object-cover ${
                                    blurPhoto
                                      ? "blur-sm scale-110 brightness-90"
                                      : ""
                                  }`}
                                />
                              </div>
                            </div>

                            {/* Details (same as small screen) */}
                            <div className="p-2 text-gray-600">
                              <h3 className="font-semibold text-xs sm:text-md truncate">
                                {profile.fullName}
                              </h3>
                              <p className="text-[11px] sm:text-md opacity-90">
                                {calculateAge(profile.dateOfBirth)} yrs •{" "}
                                {profile.height}
                              </p>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </>
            )}

            {/* View All Button */}
            <div className="mt-8 flex justify-center">
              <button
                type="button"
                onClick={() => navigate(`/${id}/${name}/profiles/male`)}
                className="px-4 sm:px-8 py-1 sm:py-3 rounded-full font-semibold flex items-center justify-center gap-2 border-2 border-rose-600 text-sm sm:text-lg text-rose-700 hover:bg-rose-50 transition w-full sm:w-auto"
              >
                View All Profiles {maleProfiles.count}
              </button>
            </div>
          </div>
        </section>

        <section className="py-8 sm:py-16 bg-gradient-to-b from-white via-rose-50 to-pink-50">
          <div id="female-profiles" className="max-w-7xl mx-auto px-4">
            <div className="flex justify-between mb-8">
              <h2 className="text-xl sm:text-3xl font-serif text-rose-900">
                Female Profiles
              </h2>

              <button
                onClick={() => navigate(`/${id}/${name}/profiles/female`)}
                className="text-rose-700 font-semibold"
              >
                {femaleProfiles.count} Profiles →
              </button>
            </div>

            {/* Swiper Section */}
            {femaleProfiles.profiles.length === 0 ? (
              <div className="flex items-center justify-center py-10 text-sm sm:text-base text-gray-500 border border-dashed border-gray-300 rounded-xl bg-gray-50 text-center">
                {t("dashboard.noProfiles")}
              </div>
            ) : (
              <>
                {/* ✅ Mobile Grid (shows 8 profiles) */}
                <div className="grid grid-cols-2 gap-3 sm:hidden">
                  {femaleProfiles.profiles.slice(0, 8).map((profile, index) => {
                    const blurPhoto = shouldBlurProfileImage(
                      profile.imagePrivacy,
                    );

                    return (
                      <div
                        key={profile.id ?? `female-grid-${index}`}
                        className="stack-card"
                        style={{ animationDelay: `${index * 120}ms` }}
                      >
                        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition cursor-pointer">
                          <div className="relative h-36 overflow-hidden bg-gray-100">
                            <img
                              src={`${UPLOAD_URL}/users/profile_pic/${profile.image}`}
                              alt={profile.fullName}
                              className={`w-full h-full object-cover ${
                                blurPhoto
                                  ? "blur-sm scale-110 brightness-90"
                                  : ""
                              }`}
                            />
                            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                          </div>
                        </div>
                        <div className="p-2 text-gray-600">
                          <h3 className="font-semibold text-xs truncate">
                            {profile.fullName}
                          </h3>
                          <p className="text-[11px] opacity-90">
                            {calculateAge(profile.dateOfBirth)} yrs •{" "}
                            {profile.height}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="hidden sm:block">
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={16}
                    slidesPerView={1.2}
                    freeMode={true}
                    grabCursor={true}
                    breakpoints={{
                      640: { slidesPerView: 2.2 },
                      1024: { slidesPerView: 3.2 },
                      1280: { slidesPerView: 4.2 },
                    }}
                    className="!pb-2"
                  >
                    {femaleProfiles.profiles.map((profile, index) => {
                      const blurPhoto = shouldBlurProfileImage(
                        profile.imagePrivacy,
                      );

                      return (
                        <SwiperSlide key={profile.id ?? `female-${index}`}>
                          <div
                            className="stack-card"
                            style={{ animationDelay: `${index * 120}ms` }}
                          >
                            {/* Image Card */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition cursor-pointer">
                              <div className="relative h-52 sm:h-56 overflow-hidden bg-gray-100">
                                <img
                                  src={`${UPLOAD_URL}/users/profile_pic/${profile.image}`}
                                  alt={profile.fullName}
                                  className={`w-full h-full object-cover ${
                                    blurPhoto
                                      ? "blur-sm scale-110 brightness-90"
                                      : ""
                                  }`}
                                />
                              </div>
                            </div>

                            {/* ✅ Same layout as mobile (no background) */}
                            <div className="p-2 text-gray-600">
                              <h3 className="font-semibold text-xs sm:text-md truncate">
                                {profile.fullName}
                              </h3>
                              <p className="text-[11px] sm:text-md opacity-90">
                                {calculateAge(profile.dateOfBirth)} yrs •{" "}
                                {profile.height}
                              </p>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </>
            )}

            {/* View All Button */}
            <div className="mt-8 flex justify-center">
              <button
                type="button"
                onClick={() => navigate(`/${id}/${name}/profiles/female`)}
                className="px-4 sm:px-8 py-1 sm:py-3 rounded-full font-semibold flex items-center justify-center gap-2 border-2 border-rose-600 text-rose-700 hover:bg-rose-50 transition text-sm sm:text-lg w-full sm:w-auto"
              >
                View All Profiles {femaleProfiles.count}
              </button>
            </div>
          </div>
        </section>

        <section
          className="py-10 sm:py-20 text-white text-center
bg-gradient-to-br from-rose-700 via-rose-600 to-pink-700
relative overflow-hidden"
        >
          <div
            className="absolute inset-0 opacity-20
  bg-[radial-gradient(circle_at_top,_white,_transparent_60%)]"
          />

          <div className="relative z-10 max-w-4xl mx-auto px-4">
            <h3
              className="reveal-up font-serif text-2xl sm:text-4xl mb-4"
              style={{ animationDelay: "0.2s" }}
            >
              Easy Find Your Life Partner
            </h3>

            <p
              className="reveal-up text-rose-100 mb-8"
              style={{ animationDelay: "0.4s" }}
            >
              Search thousands of verified profiles across India
            </p>

            <div
              className="reveal-up flex justify-center gap-5 sm:flex-wrap"
              style={{ animationDelay: "0.6s" }}
            >
              <button
                type="button"
                onClick={() =>
                  window.open(
                    `https://meemarriage.com/login`,
                    "_blank",
                  )
                }
                className="px-4 sm:px-10 py-1 sm:py-3 bg-white text-rose-700 rounded-full text-sm font-semibold shadow-lg"
              >
                Login
              </button>
              <a
                href={`/profile/${id}`}
                className="px-4 sm:px-10 py-1 sm:py-3 border border-white
        rounded-full text-sm hover:bg-white/10"
              >
                Free Register
              </a>
            </div>
          </div>
        </section>

        <section className="pt-4 pb-8 sm:pt-16 sm:pb-16 bg-gradient-to-b from-rose-50 via-white to-pink-50">
          <div className="max-w-6xl mx-auto px-4">
            <div className="grid gap-8 md:grid-cols-2 items-stretch">
              {/* LEFT CARD */}
              <div
                className="bg-white rounded-3xl shadow-xl border border-rose-100 overflow-hidden reveal-left"
                style={{ animationDelay: "0.2s" }}
              >
                <div className="px-8 py-10 text-center">
                  <h2 className="text-3xl font-semibold text-rose-900 mb-2 font-serif reveal-up">
                    Login Details
                  </h2>

                  <p
                    className="text-rose-500 text-sm mb-6 reveal-up"
                    style={{ animationDelay: "0.1s" }}
                  >
                    Login here and explore your perfect life partner
                  </p>

                  {/* Tabs */}
                  <div
                    className="flex rounded-full border border-rose-200 overflow-hidden mb-6 reveal-up"
                    style={{ animationDelay: "0.2s" }}
                  >
                    <a
                      href={`/profile/${id}`}
                      className="flex-1 px-4 py-3 bg-rose-600 text-white font-semibold text-sm"
                    >
                      Free Register
                    </a>
                    <a
                      href={`/${id}/${name}/login`}
                      target="_blank"
                      className="flex-1 px-4 py-3 text-rose-700 font-semibold text-sm hover:bg-rose-50"
                    >
                      Login
                    </a>
                  </div>

                  <a
                    href={`/profile/${id}`}
                    className="block w-full py-3 rounded-full bg-gradient-to-r from-rose-600 to-pink-600 text-white font-semibold shadow-md hover:opacity-90 transition reveal-up"
                    style={{ animationDelay: "0.3s" }}
                  >
                    Create Free Account
                  </a>

                  <div className="mt-6 text-xs text-rose-400 reveal-up">
                    or download the app
                  </div>

                  <div
                    className="mt-4 text-center reveal-up"
                    style={{ animationDelay: "0.4s" }}
                  >
                    <a
                      href="#"
                      className="inline-flex items-center justify-center gap-2 
              bg-black text-white rounded-xl 
              py-3 px-6 
              hover:opacity-90 transition"
                    >
                      <img
                        src="/images/playstore.png"
                        alt="Google Play"
                        className="h-5 w-5"
                      />
                      <div className="leading-tight text-center">
                        <div className="text-[10px]">GET IT ON</div>
                        <div className="text-sm font-semibold">Google Play</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              {/* RIGHT CARD */}
              <div
                id="contact-section"
                className="bg-white rounded-3xl shadow-xl border border-rose-100 p-8 flex flex-col items-center justify-center text-center reveal-right"
                style={{ animationDelay: "0.3s" }}
              >
                {profile?.image && (
                  <div className="mb-2">
                    <img
                      src={`${UPLOAD_URL}/bureaus/profile_pic/${profile.image}`}
                      alt="Bureau Owner"
                      className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-lg"
                      onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                  </div>
                )}

                {profile?.ownerName && (
                  <h3 className="text-xl sm:text-2xl font-bold text-rose-900 mb-4">
                    {profile.ownerName}
                  </h3>
                )}

                <h2 className="text-2xl font-bold text-rose-900 reveal-up">
                  Any Questions?
                </h2>

                <h2
                  className="text-2xl font-bold text-rose-900 mb-4 reveal-up"
                  style={{ animationDelay: "0.1s" }}
                >
                  Call Support
                </h2>

                <div className="flex flex-col sm:flex-row items-center gap-4 mt-2 reveal-up">
                  {mobile && (
                    <>
                      <button
                        onClick={() => (window.location.href = `tel:${mobile}`)}
                        className="flex items-center px-8 py-3
                bg-gradient-to-r from-rose-600 to-pink-600
                hover:from-rose-700 hover:to-pink-700
                text-white rounded-full font-semibold
                text-lg gap-2 shadow-lg transition"
                      >
                        <PhoneCall /> {mobile}
                      </button>

                      <a
                        href={`https://wa.me/${whatsappNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center px-8 py-3
    bg-[#25D366] text-white
    hover:bg-[#1ebe5d] rounded-full font-semibold
    text-lg gap-2 shadow transition"
                      >
                        <FaWhatsapp />
                        WhatsApp
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 sm:py-16 bg-gradient-to-b from-white to-rose-50 reveal-up">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-10 reveal-up">
            <h2 className="text-2xl sm:text-3xl font-semibold text-center text-rose-900 font-serif">
              Previous Customer Reviews
            </h2>

            <span className="px-3 py-1 rounded-full bg-rose-50 text-rose-700 text-sm font-semibold">
              Total {testimonials.length} Reviews
            </span>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto px-4">
            {testimonials.slice(0, 4).map((t: any, i: number) => (
              <div
                key={i}
                className="bg-white rounded-2xl shadow-md border border-rose-100 p-6 hover:shadow-xl transition reveal-up"
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                <div className="text-yellow-400 mb-2">⭐⭐⭐⭐⭐</div>

                <p className="text-gray-600 italic mb-4 text-sm">
                  "{t.message}"
                </p>

                <div className="flex items-center gap-3">
                  {getTestimonialImageUrl(t) ? (
                    <img
                      src={getTestimonialImageUrl(t)}
                      alt={t.name || "Customer review"}
                      className="h-12 w-12 rounded-full object-cover object-top scale-125 ring-2 ring-rose-100"
                    />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-rose-600 to-pink-600 text-white flex items-center justify-center font-bold text-lg">
                      {t.name?.charAt(0)}
                    </div>
                  )}

                  <div>
                    <div className="font-semibold text-rose-900">{t.name}</div>
                    <div className="text-xs text-rose-400">
                      {new Date(t.created_at).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex justify-center reveal-up">
            <button
              type="button"
              onClick={() => setShowTestimonialsModal(true)}
              className="px-8 py-3 rounded-full font-semibold border-2 border-rose-600 text-rose-700 hover:bg-rose-50 transition"
            >
              View more reviews ({testimonials.length})
            </button>
          </div>
        </section>
        {showTestimonialsModal && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
            <div className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-y-auto p-8 relative">
              <button
                className="absolute top-4 right-4 text-rose-400 hover:text-rose-700 text-2xl font-bold"
                onClick={() => setShowTestimonialsModal(false)}
              >
                &times;
              </button>

              <h3 className="text-2xl font-semibold text-center text-rose-900 mb-8 font-serif">
                All Reviews
              </h3>
              <div className="grid gap-5">
                {testimonials.map((t: any, idx: number) => (
                  <div
                    key={idx}
                    className="bg-white rounded-2xl shadow-md border border-rose-100 p-5"
                    style={{ transitionDelay: `${idx * 80}ms` }}
                  >
                    <div className="text-yellow-400 mb-2">⭐⭐⭐⭐⭐</div>

                    <p className="text-gray-600 italic mb-3 text-sm">
                      "{t.message}"
                    </p>

                    <div className="flex items-center gap-3">
                      {getTestimonialImageUrl(t) ? (
                        <img
                          src={getTestimonialImageUrl(t)}
                          alt={t.name || "Customer review"}
                          className="h-12 w-12 rounded-full object-cover object-top scale-125 ring-2 ring-rose-100"
                        />
                      ) : (
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-rose-600 to-pink-600 text-white flex items-center justify-center font-bold text-lg">
                          {t.name?.charAt(0)}
                        </div>
                      )}

                      <div>
                        <div className="font-semibold text-rose-900">
                          {t.name}
                        </div>
                        <div className="text-xs text-rose-400">
                          {new Date(t.created_at).toLocaleDateString()}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        
        <section className="py-8 sm:py-16 bg-gradient-to-b from-white via-rose-50 to-pink-50 reveal-up">
          <div
            id="follow-us-section"
            className="max-w-5xl mx-auto px-4 text-center"
          >
            {/* Heading */}
            <h3 className="text-3xl font-semibold font-serif text-rose-900 mb-3 reveal-up">
              Follow Us
            </h3>

            <p
              className="text-rose-500 mb-10 reveal-up"
              style={{ animationDelay: "0.1s" }}
            >
              Stay connected for updates, success stories and announcements
            </p>

            {/* Icons */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
              {socials.map(({ key, url, label, Icon, bg }, i) => (
                <a
                  key={key}
                  href={url as string}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-white rounded-2xl shadow-lg border border-slate-100 p-6 text-center
      hover:-translate-y-1 hover:shadow-xl transition reveal-up"
                  style={{ transitionDelay: `${i * 120}ms` }}
                >
                  <div className="flex justify-center">
                    <div
                      className={`h-16 w-16 rounded-full ${bg} flex items-center justify-center
          shadow-md group-hover:scale-105 transition`}
                    >
                      <Icon className="text-white text-3xl" />
                    </div>
                  </div>

                  <div className="mt-5 text-lg font-bold text-slate-900">
                    {label}
                  </div>

                  <div className="mt-2 text-slate-500 leading-snug">
                    Follow us on <br />
                    {label}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 sm:py-16 bg-gradient-to-b from-rose-50 via-white to-pink-50 reveal-up">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-slate-900 font-serif reveal-up">
              My Business Videos
            </h2>

            <p
              className="text-slate-500 mt-2 reveal-up"
              style={{ animationDelay: "0.1s" }}
            >
              The team will contact you to provide more details
            </p>
          </div>

          <div className="max-w-6xl mx-auto px-4">
            <div className="grid gap-6 md:grid-cols-3">
              {customizedLinks.slice(0, 3).map((link: any, i: number) => (
                <div
                  key={link.id}
                  className="bg-white rounded-3xl shadow-xl border border-rose-100 overflow-hidden reveal-up"
                  style={{ transitionDelay: `${i * 120}ms` }}
                >
                  <div className="relative bg-rose-900/10">
                    {link.thumbnail ? (
                      <img
                        src={`${UPLOAD_URL}/bureaus/customized_links/${link.thumbnail}`}
                        alt={link.title}
                        className="h-full w-full object-contain obj-center"
                      />
                    ) : (
                      <div className="h-full w-full flex items-center justify-center text-rose-500 text-4xl">
                        ▶
                      </div>
                    )}

                    <span className="absolute bottom-3 left-3 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-rose-700">
                      Watch Now
                    </span>
                  </div>

                  <div className="p-6">
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">
                      {link.title}
                    </h3>

                    <p className="text-sm text-slate-500 mb-5">
                      Full information video
                    </p>

                    <a
                      href={link.url_link}
                      target="_blank"
                      className="inline-flex items-center justify-center gap-2 w-full rounded-2xl bg-gradient-to-r from-rose-600 to-pink-600 text-white font-semibold py-3 shadow-md hover:opacity-90 transition"
                    >
                      <span className="text-lg">▶</span>
                      Watch Video
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {customizedLinks.length > 3 && (
              <div
                className="mt-8 flex justify-center reveal-up"
                style={{ animationDelay: "0.3s" }}
              >
                <button
                  type="button"
                  onClick={() => setShowMoreInfoModal(true)}
                  className="px-8 py-3 rounded-full font-semibold border-2 border-rose-600 text-rose-700 hover:bg-rose-50 transition"
                >
                  View More
                </button>
              </div>
            )}

            {showMoreInfoModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
                <div className="bg-white rounded-3xl shadow-2xl max-w-6xl w-full max-h-[85vh] overflow-y-auto p-8 relative">
                  <button
                    className="absolute top-4 right-4 text-rose-400 hover:text-rose-700 text-2xl font-bold"
                    onClick={() => setShowMoreInfoModal(false)}
                  >
                    &times;
                  </button>

                  <h3 className="text-2xl font-semibold text-center text-slate-900 mb-8 font-serif">
                    For More Info
                  </h3>

                  <div className="grid gap-6 md:grid-cols-3">
                    {customizedLinks.map((link: any, i: number) => (
                      <div
                        key={link.id}
                        className="bg-white rounded-3xl shadow-xl border border-rose-100 overflow-hidden reveal-up"
                        style={{ transitionDelay: `${i * 80}ms` }}
                      >
                        <div className="relative h-48 bg-rose-900/10">
                          {link.thumbnail ? (
                            <img
                              src={`${UPLOAD_URL}/bureaus/customized_links/${link.thumbnail}`}
                              alt={link.title}
                              className="h-full w-full object-cover"
                            />
                          ) : (
                            <div className="h-full w-full flex items-center justify-center text-rose-500 text-4xl">
                              ▶
                            </div>
                          )}

                          <div className="absolute inset-0 bg-gradient-to-r from-rose-900/50 via-rose-700/30 to-transparent" />

                          <span className="absolute bottom-3 left-3 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-rose-700">
                            Watch Now
                          </span>
                        </div>

                        <div className="p-6">
                          <h3 className="text-lg font-semibold text-slate-900 mb-2">
                            {link.title}
                          </h3>

                          <p className="text-sm text-slate-500 mb-5">
                            Full information video
                          </p>

                          <a
                            href={link.url_link}
                            target="_blank"
                            className="inline-flex items-center justify-center gap-2 w-full rounded-2xl bg-gradient-to-r from-rose-600 to-pink-600 text-white font-semibold py-3 shadow-md hover:opacity-90 transition"
                          >
                            <span className="text-lg">▶</span>
                            Watch Video
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <section
          id="packages-section"
          className="py-8 sm:py-16 bg-gradient-to-b from-rose-50 via-white to-pink-50"
        >
          {packages.length > 0 && (
            <div className="container mx-auto px-4">
              {/* Heading */}
              <div className="text-center mb-12 reveal-up">
                <h2
                  className="text-2xl sm:text-4xl md:text-5xl font-semibold font-serif 
                 bg-gradient-to-r from-rose-600 via-pink-600 to-rose-700 
                 bg-clip-text text-transparent mb-4"
                >
                  Our Premium Packages
                </h2>

                <div
                  className="w-24 h-1 mx-auto 
                 bg-gradient-to-r from-rose-500 to-pink-500 rounded-full"
                />
              </div>

              {/* Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                {packages.map((pkg: any, index) => (
                  <div
                    key={pkg.id}
                    className="relative group reveal-up"
                    style={{ transitionDelay: `${index * 120}ms` }}
                  >
                    <div
                      className="bg-white rounded-3xl shadow-lg border border-rose-100
                     hover:shadow-2xl transition-all duration-500
                     transform hover:-translate-y-2 overflow-hidden"
                    >
                      {/* Header Gradient */}
                      <div
                        className="relative p-8 text-white
                  bg-gradient-to-br from-rose-600 via-pink-600 to-rose-700"
                      >
                        {/* Decorative blobs */}
                        <div
                          className="absolute top-0 right-0 w-32 h-32 
                    bg-white/10 rounded-full -translate-y-16 translate-x-16"
                        />
                        <div
                          className="absolute bottom-0 left-0 w-24 h-24 
                    bg-white/10 rounded-full translate-y-12 -translate-x-12"
                        />

                        <div className="relative z-10">
                          <h3 className="text-2xl font-semibold mb-2">
                            {pkg.title}
                          </h3>

                          <div className="flex items-end justify-between">
                            <div>
                              <span className="text-3xl font-bold">
                                ₹{parseFloat(pkg.price).toLocaleString()}
                              </span>
                              <span className="text-rose-100 text-sm ml-2">
                                /package
                              </span>
                            </div>

                            <span
                              className="bg-white/20 backdrop-blur px-4 py-1.5 
                        rounded-full text-xs font-semibold"
                            >
                              {pkg.duration} Validity
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-8">
                        <p className="text-rose-600 text-sm mb-6 leading-relaxed">
                          {pkg.description}
                        </p>

                        {/* Features Array */}
                        {pkg.features &&
                          Array.isArray(pkg.features) &&
                          pkg.features.length > 0 && (
                            <div className="mb-8">
                              <h4 className="text-lg font-semibold text-rose-900 mb-4">
                                Features Included:
                              </h4>

                              <ol className="space-y-3 list-decimal list-inside">
                                {pkg.features.map(
                                  (feature: any, index: any) => (
                                    <li key={index} className="flex gap-3">
                                      <div
                                        className="w-5 h-5 rounded-full 
                                bg-gradient-to-r from-rose-500 to-pink-500 
                                flex items-center justify-center flex-shrink-0 mt-1"
                                      >
                                        <svg
                                          className="w-3 h-3 text-white"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 
                                    8a1 1 0 01-1.414 0l-4-4a1 1 
                                    0 011.414-1.414L8 12.586l7.293-7.293
                                    a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </div>

                                      <span className="text-rose-700 text-sm">
                                        {feature}
                                      </span>
                                    </li>
                                  ),
                                )}
                              </ol>
                            </div>
                          )}

                        {/* Features String */}
                        {pkg.features &&
                          typeof pkg.features === "string" &&
                          pkg.features.trim() !== "" && (
                            <div className="mb-8">
                              <h4 className="text-lg font-semibold text-rose-900 mb-4">
                                Features Included:
                              </h4>

                              <ol className="space-y-3 list-decimal list-inside">
                                {(function () {
                                  let arr;
                                  try {
                                    arr = JSON.parse(pkg.features);
                                    if (!Array.isArray(arr))
                                      arr = pkg.features.split(",");
                                  } catch {
                                    arr = pkg.features.split(",");
                                  }

                                  return arr.map((feature: any, index: any) => (
                                    <li key={index} className="flex gap-3">
                                      <div
                                        className="w-5 h-5 rounded-full 
                                  bg-gradient-to-r from-rose-500 to-pink-500 
                                  flex items-center justify-center flex-shrink-0 mt-1"
                                      >
                                        <svg
                                          className="w-3 h-3 text-white"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 
                                      1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 
                                      1 0 011.414-1.414L8 12.586l7.293-7.293
                                      a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </div>

                                      <span className="text-rose-700 text-sm">
                                        {feature.trim()}
                                      </span>
                                    </li>
                                  ));
                                })()}
                              </ol>
                            </div>
                          )}

                        {/* Created Date */}
                        {/* <div className="flex items-center text-xs text-rose-400 mb-6">
                          {new Date(pkg.created_at).toLocaleDateString()}
                        </div> */}

                        <button
                          className="w-full flex items-center justify-center gap-2
                      bg-gradient-to-r from-rose-600 to-pink-600
                      hover:opacity-90 text-white py-4 rounded-xl
                      font-semibold shadow-lg transition"
                          onClick={() => {
                            const phone = mobile
                              ? mobile.replace(/[^0-9]/g, "")
                              : "";

                            const msg = encodeURIComponent(
                              `I am interested in this package: ${
                                pkg.title
                              }, Price: ₹${parseFloat(
                                pkg.price,
                              ).toLocaleString()}, Duration: ${pkg.duration}.`,
                            );

                            window.open(
                              `https://wa.me/${phone}?text=${msg}`,
                              "_blank",
                            );
                          }}
                        >
                          Pay Now ₹{parseFloat(pkg.price).toLocaleString()}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>

        <section className="py-8 sm:py-16 bg-gradient-to-b from-rose-50 to-rose-100">
          {services && services.length > 0 && (
            <div id="services-section" className="max-w-6xl mx-auto px-4">
              {/* Heading */}
              <div className="text-center mb-10 reveal-up">
                <h3 className="text-3xl font-semibold font-serif text-rose-900 mb-3">
                  Our Services
                </h3>

                <div
                  className="w-20 h-1 mx-auto 
          bg-gradient-to-r from-rose-500 to-pink-500 rounded-full"
                />
              </div>

              {/* Grid */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {services.map((service: any, idx) => (
                  <div
                    key={service.id}
                    className="bg-white border border-rose-100 
              rounded-2xl p-6 shadow-md hover:shadow-xl
              transition-all duration-300 reveal-up"
                    style={{ transitionDelay: `${idx * 120}ms` }}
                  >
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-gradient-to-br from-rose-500 to-pink-600 text-white font-bold">
                        ✓
                      </div>

                      <span className="text-rose-900 font-semibold text-sm leading-relaxed break-all">
                        {service.Servicename}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>

        {/* <section className="py-16 bg-gradient-to-b from-rose-50 via-white to-pink-50">
          {locations && locations.length > 0 && (
            <div id="locations-section" className="max-w-6xl mx-auto px-4">
              <div className="text-center mb-10">
                <h3 className="text-3xl font-semibold font-serif text-rose-900 mb-3">
                  Branch Locations
                </h3>
                <div
                  className="w-20 h-1 mx-auto 
          bg-gradient-to-r from-rose-500 to-pink-500 rounded-full"
                />
              </div>

              <div
                className="bg-white rounded-3xl shadow-lg border border-rose-100 
        p-8 transition hover:shadow-xl"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div
                    className="p-3 rounded-full 
            bg-gradient-to-br from-rose-500 to-pink-600 text-white"
                  >
                    👤
                  </div>

                  <div>
                    <p className="text-xs text-rose-400 font-semibold">
                      Branch Manager
                    </p>
                    <p className="font-semibold text-rose-900">
                      {locations[0].branch_manager_name}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4 mb-6">
                  <div
                    className="p-3 rounded-full 
            bg-gradient-to-br from-rose-500 to-pink-600 text-white"
                  >
                    📞
                  </div>

                  <div>
                    <p className="text-xs text-rose-400 font-semibold">
                      Contact
                    </p>
                    <p className="text-rose-900">
                      {locations[0].contact_details}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 mb-6">
                  <div
                    className="p-3 rounded-full 
            bg-gradient-to-br from-rose-500 to-pink-600 text-white"
                  >
                    📍
                  </div>

                  <div className="text-sm text-rose-700 space-y-1">
                    <p>
                      <strong>House:</strong> {locations[0].house_no || "-"}
                    </p>
                    <p>
                      <strong>Street:</strong> {locations[0].street || "-"}
                    </p>
                    <p>
                      <strong>City:</strong> {locations[0].city || "-"}
                    </p>
                    <p>
                      <strong>District:</strong> {locations[0].district || "-"}
                    </p>
                    <p>
                      <strong>State:</strong> {locations[0].state || "-"}
                    </p>
                    <p>
                      <strong>Country:</strong> {locations[0].country || "-"}
                    </p>
                  </div>
                </div>

                {locations[0].google_map_link && (
                  <a
                    href={locations[0].google_map_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2
              px-6 py-3 rounded-full
              bg-gradient-to-r from-rose-600 to-pink-600
              text-white font-semibold shadow hover:opacity-90"
                  >
                    View on Google Maps
                  </a>
                )}
              </div>

              {locations.length > 1 && (
                <div className="flex justify-center mt-8">
                  <button
                    className="px-8 py-3 rounded-full font-semibold
              bg-gradient-to-r from-rose-600 to-pink-600
              text-white shadow-lg hover:opacity-90"
                    onClick={() => setShowLocationsModal(true)}
                  >
                    View More Branches ({locations.length - 1})
                  </button>
                </div>
              )}

              {showLocationsModal && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center 
          bg-black/40 backdrop-blur-sm"
                >
                  <div
                    className="bg-white rounded-3xl shadow-2xl 
            max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative"
                  >
                    <button
                      className="absolute top-4 right-4 text-rose-400 
                hover:text-rose-700 text-2xl font-bold"
                      onClick={() => setShowLocationsModal(false)}
                    >
                      &times;
                    </button>

                    <h3
                      className="text-2xl font-semibold text-center 
              text-rose-900 mb-8 font-serif"
                    >
                      All Branch Locations
                    </h3>

                    <div className="space-y-6">
                      {locations.slice(1).map((loc, idx) => (
                        <div
                          key={loc.id}
                          className="border border-rose-100 rounded-xl p-5 
                    bg-rose-50/40"
                        >
                          <p className="font-semibold text-rose-900">
                            {loc.branch_manager_name}
                          </p>
                          <p className="text-rose-600 text-sm">
                            {loc.contact_details}
                          </p>
                          <p className="text-rose-500 text-sm mt-1">
                            {loc.city}, {loc.state}, {loc.country}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </section> */}

        <section className="py-8 sm:py-16 bg-gradient-to-b from-rose-50 via-white to-pink-50">
          {locations && locations.length > 0 && (
            <div id="locations-section" className="max-w-6xl mx-auto px-4">
              {/* Heading */}
              <div className="text-center mb-10 reveal-up">
                <h3 className="text-3xl font-semibold font-serif text-rose-900 mb-3">
                  Branch Locations
                </h3>

                <div className="w-20 h-1 mx-auto bg-gradient-to-r from-rose-500 to-pink-500 rounded-full" />
              </div>

              {/* Locations Grid */}
              <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {locations.map((loc, idx) => (
                  <div
                    key={loc.id}
                    className="bg-white rounded-2xl border border-rose-100 shadow-sm hover:shadow-md transition p-5 reveal-up"
                    style={{ transitionDelay: `${idx * 120}ms` }}
                  >
                    <h4 className="text-lg font-semibold text-rose-900 font-serif mb-3">
                      {loc.city ? `${loc.city} Branch` : "Branch Location"}
                    </h4>

                    <p className="text-sm text-slate-600">
                      <span className="font-semibold text-rose-700">
                        Manager:
                      </span>{" "}
                      {loc.branch_manager_name || "-"}
                    </p>

                    <p className="text-sm text-slate-600 mt-1">
                      <span className="font-semibold text-rose-700">
                        Contact:
                      </span>{" "}
                      {loc.contact_details ? (
                        <a
                          href={`tel:${loc.contact_details}`}
                          className="hover:underline"
                        >
                          {loc.contact_details}
                        </a>
                      ) : (
                        "-"
                      )}
                    </p>

                    <p className="text-sm text-slate-600 mt-2 leading-relaxed">
                      {[
                        loc.house_no,
                        loc.street,
                        loc.city,
                        loc.district,
                        loc.state,
                        loc.country,
                      ]
                        .filter(Boolean)
                        .join(", ") || "-"}
                    </p>

                    {loc.google_map_link && (
                      <a
                        href={loc.google_map_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-4 text-sm font-semibold text-rose-600 hover:text-rose-800"
                      >
                        View on Google Maps →
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>

        {/* Success Stories Gallery Section */}
        {successStories && successStories.length > 0 && (
          <section className="py-8 sm:py-20 bg-gradient-to-b from-rose-50 via-white to-pink-50">
            <div className="max-w-6xl mx-auto px-4">
              {/* Heading */}
              <div className="text-center mb-4 sm:mb-14 reveal-up">
                <h3 className="text-3xl font-serif font-semibold text-rose-900">
                  Total {successStories.length}+
                </h3>

                <h3 className="text-3xl font-serif font-semibold text-rose-900 mb-2">
                  Success Stories
                </h3>

                <p className="text-rose-500">
                  Real couples who found their perfect match
                </p>
              </div>

              {/* Cards */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
                {successStories.slice(0, 6).map((story: any, idx) => (
                  <div
                    key={story.id || idx}
                    className="bg-white border border-rose-100 rounded-3xl
            shadow-lg hover:shadow-xl transition-all overflow-hidden reveal-up"
                    style={{ transitionDelay: `${idx * 120}ms` }}
                  >
                    <img
                      src={`${UPLOAD_URL}/bureaus/stories/${story.image_path}`}
                      className="h-60 w-full object-cover"
                      alt=""
                    />

                    <div className="p-6">
                      {story.title && (
                        <h4 className="text-md font-semibold text-gray-900 mb-1">
                          {story.title}
                        </h4>
                      )}

                      <div className="flex justify-between">
                        {story.marriage_date && (
                          <p className="text-sm text-gray-500">
                            Married:{" "}
                            {new Date(story.marriage_date).toLocaleDateString(
                              "en-IN",
                            )}
                          </p>
                        )}

                        {story.createdAt && (
                          <p className="text-sm text-gray-500">
                            Posted on:{" "}
                            {new Date(story.createdAt).toLocaleDateString(
                              "en-IN",
                            )}
                          </p>
                        )}
                      </div>

                      {story.description && (
                        <p className="text-gray-700 text-xs mt-2 line-clamp-3">
                          {story.description}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {successStories.length > 5 && (
                <div className="mt-12 text-center reveal-up">
                  <button
                    className="px-8 py-3 rounded-full font-semibold
            bg-gradient-to-r from-rose-600 to-pink-600
            text-white shadow-lg hover:opacity-90"
                    onClick={() => {
                      navigate(`/${id}/${name}/success-stories`);
                    }}
                  >
                    View All Success Stories
                  </button>
                </div>
              )}
            </div>
          </section>
        )}
        <Footer navbarLogo={navbarLogo} bureauInfo={bureauInfo} />
      </main>
    </div>
  );
};

export default MyWebSite;
